import { Alert, Box, Grid, IconButton, Typography } from "@mui/material";
import { OutreachTemplatesContext } from "contexts/OutreachTemplates";
import { capitalize } from "lodash";
import { Dispatch, SetStateAction, useContext } from "react";

import {
  Template,
  TemplateContentType,
} from "features/Influencer/ContactList/schema";

import styles from "./styles";

interface Props {
  setOpenEditFallbackDrawer: Dispatch<SetStateAction<boolean>>;
  fallbackTemplates: Template[];
}

const DefaultTemplate = ({
  setOpenEditFallbackDrawer,
  fallbackTemplates,
}: Props) => {
  const { setEditTemplateDialogId } = useContext(OutreachTemplatesContext);

  return (
    <Box sx={styles.defaultTemplateBox}>
      <Grid
        container
        onClick={() => setOpenEditFallbackDrawer(true)}
        gap={2}
        alignItems={"center"}
        sx={{ position: "relative" }}
      >
        <IconButton
          size="small"
          onClick={(e) => {
            e.stopPropagation();
            setOpenEditFallbackDrawer(true);
          }}
          sx={{
            color: "primary.main",
            flexShrink: 0,
            position: "absolute",
            top: 0,
            right: 10,
          }}
        >
          <Box component="span" className="fa-regular fa-pen" />
        </IconButton>
        <Grid item xs={12} lg="auto">
          <Typography variant="h6" sx={{ mb: 1 }}>
            Current fallback templates{" "}
          </Typography>
          {fallbackTemplates.length > 0 ? (
            <Box gap={1}>
              {fallbackTemplates.map((t, index) => (
                <Box
                  key={t.id}
                  sx={{
                    backgroundColor: "white",
                    p: 2,
                    borderRadius: 3,
                    mb: 2,
                    border: "1px solid",
                  }}
                  onClick={(e) => {
                    e.stopPropagation();
                    if (t.id) setEditTemplateDialogId(t.id.toString());
                  }}
                >
                  <Typography
                    variant="subtitle2"
                    color="textSecondary"
                    sx={{ mb: 0.5, fontSize: 12 }}
                  >
                    {capitalize(t.contentType)}{" "}
                    {t.contentType === TemplateContentType.FOLLOWUP
                      ? `#${index}`
                      : ""}
                  </Typography>
                  <Typography
                    noWrap
                    sx={{
                      maxWidth: 250,
                      overflow: "hidden",
                      textOverflow: "ellipsis",
                    }}
                  >
                    {t.name}
                  </Typography>
                </Box>
              ))}
            </Box>
          ) : (
            <Alert severity="warning">
              No default template is set. Please set one to ensure emails can be
              sent.
            </Alert>
          )}
        </Grid>
        <Grid item xs={12} lg gap={1}>
          <Typography
            sx={{ fontSize: { xs: 12, lg: 16 }, p: { xs: 0, lg: 3 } }}
          >
            <Box
              component="i"
              className="fa-solid fa-circle-info"
              sx={{ mr: 0.5, color: "green.main" }}
            />
            These templates are used when AI can't confidently identify a
            brand's category. Keep it broad enough to work as a pitch for any
            brand.
          </Typography>
        </Grid>
      </Grid>
    </Box>
  );
};

export default DefaultTemplate;
